import { NotificationsActive } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { action, observable, runInAction, makeObservable } from 'mobx';
import {  observer } from 'mobx-react';
import React, { Fragment } from 'react';
import NotificacaoStore from '../store/NotificacaoStore';
import './css/notificacao.css';
import Modal from './Modal';

interface IPropsCountMinutasDevolvidas {
}


class Notificacao extends React.Component {
    animationName = '';

    componentDidMount() {
        this.tocar();
    }

    tocar = () => {
        setTimeout(() => {
            runInAction(() => {
                if (this.animationName !== 'tocando') {
                    this.animationName = 'tocando'
                } else {
                    this.animationName = 'nao-tocar'
                }
            });
            this.tocar();
        }, 1000);
    }

    abrirModalNotificacoes = () => {
        NotificacaoStore.modalNotificacoesAberto = true;
    };

    fecharModalNotificacoes = () => {
        NotificacaoStore.modalNotificacoesAberto = false;
    };

    descartarNotificacoes = () => {
        NotificacaoStore.notificacoes = [];
        this.fecharModalNotificacoes();
    };

    fecharNotificacoes = () => {
        this.fecharModalNotificacoes();
    };


    constructor(props: IPropsCountMinutasDevolvidas) {
        super(props);

        makeObservable(this, {
            animationName: observable,
            abrirModalNotificacoes: action,
            fecharModalNotificacoes: action,
            descartarNotificacoes: action,
            fecharNotificacoes: action
        });
    }


    render() {
        return (
            <Tooltip title={NotificacaoStore.temNotificacao ? 'Visualizar pendências' : 'Sem notificações'}>
                <div
                    className="notificacao-ativa"
                    style={{
                        animationName: NotificacaoStore.temNotificacao ? 'tocando' : 'nao-tocar'
                    }}
                >
                    <IconButton style={{ color: NotificacaoStore.temNotificacao ? 'yellow' : 'white' }} onClick={this.abrirModalNotificacoes} aria-label='Abrir painel de pendências do gabinete.'>
                        <NotificationsActive />
                    </IconButton>
                    {NotificacaoStore.temNotificacao ?
                        <Modal
                            aberto={NotificacaoStore.modalNotificacoesAberto}
                            fecharModal={this.fecharNotificacoes}
                            funcaoAcaoPrimaria={this.fecharModalNotificacoes}
                            labelAcaoPrimaria='Analisar posteriormente'
                            funcaoAcaoSecundaria={this.descartarNotificacoes}
                            labelAcaoSecundaria='Ignorar notificações'
                            titulo='Notificações'
                            maxWidth='sm' fullWidth
                        >
                            <div className='div-modal-notificacoes'>
                                {NotificacaoStore.notificacoes?.map((notificacao, index) => <Fragment key={index}>{notificacao.componente}</Fragment>)}
                            </div>
                        </Modal>
                        :
                        <Modal
                            aberto={NotificacaoStore.modalNotificacoesAberto}
                            fecharModal={this.fecharNotificacoes}
                            funcaoAcaoSecundaria={this.descartarNotificacoes}
                            labelAcaoSecundaria='Fechar'
                            titulo='Sem Notificações'
                            maxWidth='sm' fullWidth
                        >
                            <div className='div-modal-notificacoes'>
                                Você não possui notificações pendentes ou já visualizou todas as disponíveis.
                            </div>
                        </Modal>
                    }
                </div>
            </Tooltip>
        );
    }
}

export default observer(Notificacao);
